import React, { createContext, useState, useEffect } from 'react';
import { authService } from '../services/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is already logged in (from localStorage or sessionStorage)
    const checkAuthStatus = async () => {
      try {
        const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
        
        if (token) {
          const userData = await authService.validateToken(token);
          setUser(userData);
        }
      } catch (err) {
        console.error('Auth validation error:', err);
        // Clear any invalid tokens
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
      } finally {
        setLoading(false);
      }
    };
    
    checkAuthStatus();
  }, []);

  const login = async (credentials) => {
    setError(null);
    try {
      const { userType, email, password, rememberMe } = credentials;
      const { user, token } = await authService.login(userType, email, password);
      
      // Store token based on rememberMe preference
      if (rememberMe) {
        localStorage.setItem('authToken', token);
      } else {
        sessionStorage.setItem('authToken', token);
      }
      
      // Add user initials for UI display
      const names = user.name.split(' ');
      user.initials = names.length > 1 
        ? `${names[0][0]}${names[names.length - 1][0]}` 
        : names[0].substring(0, 2);
      
      setUser(user);
      return user;
    } catch (err) {
      setError(err.message || 'Falha na autenticação');
      throw err;
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
      setUser(null);
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;